import { FC } from "react";
import Modal from "../../../components/Modal";
import Text from "../../../components/Text";

import styles from "./styles.module.scss";
import Button from "../../../components/Button";
import { logout } from "../../../services/authService";
import { acceptCgu } from "../../../services/api/user";
import { refreshTokenService } from "../../../services/api/auth";
import { getRefreshToken, setAccessToken } from "../../../utils/jwt";

type Props = {
    isModalOpen: boolean;
    setIsModalOpen: (open: boolean) => void;
    pdfUrl?: string; // optional URL to the CGU PDF (defaults to /cgu.pdf)
};

const CguModal: FC<Props> = ({
    isModalOpen,
    setIsModalOpen,
    pdfUrl = "/cgu.pdf",
}) => {
    const handleAcceptCgu = async () => {
        await acceptCgu();

        const refreshToken = getRefreshToken();
        if (!refreshToken) return;

        const { accessToken } = await refreshTokenService(refreshToken);
        setAccessToken(accessToken);

        setIsModalOpen(false);
    };

    return (
        <Modal
            className={styles.modal}
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            canClose={false}
        >
            <Text variant="title">
                Mise à jour des Conditions Générales d'Utilisation
            </Text>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "80vh",
                }}
            >
                <div style={{ flex: 1, minHeight: 0 }}>
                    <iframe
                        src={pdfUrl}
                        title="Conditions Générales d'Utilisation"
                        style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                        }}
                    />
                </div>
            </div>
            <Text variant="body">
                Nos Conditions Générales d'Utilisations ont été mises à jour.
                Pour continuer à utiliser le service, merci de les accepter.
            </Text>
            <div className={styles.actions}>
                <Button variant="transparent" onClick={() => logout()}>
                    Refuser
                </Button>
                <Button variant="secondary" onClick={handleAcceptCgu}>
                    Accepter
                </Button>
            </div>
        </Modal>
    );
};

export default CguModal;
